<template>
    <div>
      <p>Logging in...</p>
    </div>
  </template>
  
  <script>
  export default {
    async mounted() {
      const code = this.$route.query.code;
      console.log('code', code);
      if (code) {
        await this.$store.dispatch('admin/loginWithSkyTab', { code });
        this.$router.push({ name: 'admin' }); // Redirect to admin view after login
      } else {
        // Handle error (e.g., display a message to the user)
        console.error('Authorization code not found');
      }
    }
  };
  </script>